// Los primeros colores conservan los que ya tenían Administrador, Compras, TI y E-commerce (ids 1-4).
const PALETA_ROLES = ["#F97316", "#3B82F6", "#7E22CE", "#EAB308", "#10B981", "#EC4899", "#14B8A6", "#6366F1"];

export function colorRol(id) {
  const n = Number(id);
  if (!Number.isInteger(n) || n < 1) return "#6c757d";
  return PALETA_ROLES[(n - 1) % PALETA_ROLES.length];
}
